import { PropsWithChildren } from 'react';

import {
  OrderProvider,
  OrderProviderProps,
} from 'modules/account/orderModule/common/providers/OrderProvider';

interface CreateOrderProviderProps extends OrderProviderProps {}

export const CreateOrderProvider = ({
  children,
  ...props
}: CreateOrderProviderProps & PropsWithChildren) => (
  <OrderProvider {...props}>{children}</OrderProvider>
);
